import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const assignAssetToCategory = (category, asset) => request.put(`${API_BASE_URL}/blockchain/category/${category}/assets/${asset}/add`)

export default assignAssetToCategory